import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAll } from 'services/marketplaces.service';
import { STATUSES } from 'redux/statuses';

export const setMarketplacesIfEmpty = createAsyncThunk(
  'marketplaces/setMarketplacesIfEmpty',
  async (payload, { getState }) => {
    try {
      const { data } = await getAll();
      return data;
    } catch (error) {
      console.error(error);
    }
  },
  {
    condition(payload, { getState }) {
      const { marketplaces } = getState();
      return marketplaces.status === STATUSES.EMPTY;
    },
  },
);

const initialState = {
  status: STATUSES.EMPTY,
  items: [],
};

const marketplacesSlice = createSlice({
  name: 'marketplaces',
  initialState,
  reducers: {
    setMarketplaces(state, action) {
      return {
        status: STATUSES.FULFILLED,
        items: action.payload,
      };
    },
    unsetMarketplaces(state, action) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setMarketplacesIfEmpty.pending, (state, action) => {
        state.status = STATUSES.PENDING;
      })
      .addCase(setMarketplacesIfEmpty.fulfilled, (state, action) => {
        return {
          status: STATUSES.FULFILLED,
          items: action.payload,
        };
      });
  },
});

export const { setMarketplaces, unsetMarketplaces } = marketplacesSlice.actions;

export default marketplacesSlice.reducer;
